import { Container } from "@material-ui/core";
import React from "react";
import { Col, Row } from "react-bootstrap";
import challangeImg from "../../images/agri-retailers-challenges.png";

import Monetize from "../../images/tracable-products.svg";
import Order from "../../images/delivery.svg";

const AgriRetailerChallenge = () => {
    const challanges =[{
        title:"Tracable Agri-inputs",
        description:"Securing traceable agri-inputs is challenging for agri-retailers due to fragmented supply chains and limited access to advanced tracking systems. This complexity hinders the ability to ensure product authenticity and regulatory compliance.    ",
        image:Monetize
      },
    
 
      {
        title:"Getting more business (orders)",
        description:"The constant struggle to get more orders is a big challenge for agri-retailers and farmers, requiring smart strategies and constant innovation to stand out in a competitive market.",
        image:Order
      },
    //   {
    //     title:"Market Access",
    //     description:"Farmers face the challenge of limited market access, hindering their ability to reach a broader audience and maximize the potential for their agricultural products.",
    //     image:Ecosystem
    //   },
    
      // {
      //   title:"Brand ",
      //   description:"Branding empowers farmers to establish unique identities for their products, enabling differentiation and market recognition. ",
      //   image:Brand
      // }
    //  {
    //     title:"Easy Technology adoption ",
    //     description:"Affordable and user-friendly integrated agricultural technologies, enhancing productivity and efficiency on farms, are increasingly sought after by farmers.",
    //     image:Technology
    //   }
    ]
    return(
        <Container className="challenge-container subSectionWrapper ">
        <h2 className="container-title mb-md-5 text-center">
          Agri-Retailer challenges
        </h2>
  
        <Row className="align-items-center">
          <Col md={4}>
            <img src={challangeImg} alt="challange " className="mb-md-0 mb-4" />
          </Col>
  
          <Col md={8}>
           
  
            <Row className="challangesRow justify-content-between ">
              {challanges.map((e,i)=>{
                return <Col md={6} sm={6} xs={10} className="d-flex" key={i}>
                <div className="challangeCards  mb-md-4 ">
                  <img src={e.image} alt="Challange Icon" className="mb-3" />
                  <h6 className="mb-2">{e.title}</h6>
                  <p className="mb-0">
                   {e.description}
                  </p>
                </div>
              </Col>
             
              })}          
            </Row>
     
          </Col>
        </Row>
      </Container>
    )
};

export default AgriRetailerChallenge
